<template>
  <div
    :style="{ 'background-image': `url(${imageData || imgprofile})` }"
    @click="chooseImage"
    class="bg-cover	bg-no-repeat	bg-center	relative bg-blueSalude rounded-full flex justify-center items-center "
    :class="`w-150 h-150 text-extrabig`"
  >
    <span
      v-if="!imageData && !imgprofile"
      class="text-white font-semibold uppercase"
    >
      {{ name }}{{ lname }}
    </span>

    <div class="bg-white absolute cameraposition rounded-full p-s">
      <Camera />
    </div>

    <input ref="fileInput" type="file" hidden @input="onSelectFile" />
  </div>
</template>

<script>
import Camera from "./icons/Camera.vue";
import toastr from "toastr";

export default {
  components: {
    Camera,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    lname: {
      type: String,
      required: true,
    },
    imageData: {
      default: null,
      required: false,
    },
  },
  data() {
    return {
      user: "AM",
      title: "",
      content: "",
      file: "",
      imgprofile: "",
    };
  },
  mounted() {},
  methods: {
    chooseImage() {
      this.$refs.fileInput.click();
    },
    onSelectFile() {
      const input = this.$refs.fileInput;
      const files = input.files;
      if (
        files[0].type === "image/png" ||
        files[0].type === "image/jpg" ||
        files[0].type === "image/jpeg" ||
        files[0].type === "image/webp"
      ) {
        var sizeByte = files[0].size;
        var siezekiloByte = parseInt(sizeByte / 1024);

        if (siezekiloByte > 8192) {
          toastr.error("La imagen debe pesar menos de 8mb");
        }

        if (files && files[0]) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.imgprofile = e.target.result;
          };
          reader.readAsDataURL(files[0]);
          this.$emit("input", files[0]);
        }

        let formData = new FormData();
        formData.append("imagen", files[0]);

        this.$store.commit("userImageProfile/SET_USERIMAGE", formData);
      } else {
        toastr.error("Formato de imagen no permitido");
      }
    },
  },
};
</script>

<style scoped>
.w-36-px {
  width: 36px;
}

.h-35-px {
  height: 35px;
}

.cameraposition {
  bottom: 20px;
  right: -10px;
}
</style>
